/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from '@fortawesome/free-solid-svg-icons';
import FormInput from "./FormInput";
import { SidebarGlobal } from "./_Sidebar";
import Globals from "../shared/Globals";
import DataTable from "./DataTable";
import Paging from "./Paging";
import Icon from "./Icon";
import Rating from "./Rating";
import Auth from "../shared/Auth";
import { Dropdown, DropdownButton, DropdownItem } from "react-bootstrap";
import { Pop } from "./PopModal";
import AppActions from "./AppActions";

class LeadsMenu extends BaseCom {
    render() {
        return <>
            <ul className="app-tabs nav nav-tabs">
                <li className="nav-item"><NavLink to="/lead/inbound" className="nav-link" role="tab" aria-selected="true"><L>Inbound</L> <span className="d-none d-md-inline"><L>Referral</L></span></NavLink></li>
                <li className="nav-item"><NavLink to="/lead/onhold" className="nav-link" role="tab" aria-selected="true"><span className="d-none d-md-inline"><L>On</L> </span><L>Hold</L></NavLink></li>
                <li className="nav-item"><NavLink to="/lead/declined" className="nav-link" role="tab" aria-selected="true"><L>Declined</L></NavLink></li>
                <li className="nav-item"><NavLink to="/lead/not-qualified" className="nav-link" role="tab" aria-selected="true"><L>Not&nbsp;Qualified</L></NavLink></li>
                {Auth.hasRole('manager') && <li className="nav-item"><NavLink to="/lead/pending" className="nav-link" role="tab" aria-selected="true"><span className="d-none d-md-inline"><L>Outbound</L> </span><L>Pending</L></NavLink></li>}
                <li className="nav-item"><NavLink to="/lead/outbound" className="nav-link" role="tab" aria-selected="true"><L>Outbound</L> <span className="d-none d-md-inline"><L>Referral</L></span></NavLink></li>
            </ul>
            <div className="p-4"></div>
        </>;
    }
}

class Leads extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: props.params.page ?? 1,
                qfilters: {},
                sort: 'o.createddate DESC'
            },
            bucket: props.params.bucket,
            loaded: false,
            loading: false,
            list: [],
            actionList: [],
            userList: [],
            typeList: [],
            sourceList: [],
            pageCount: 0,
            totalCount: 0
        };
        this.load = this.load.bind(this);
        this.search = this.search.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.hasFilters = this.hasFilters.bind(this);
        this.approveSelected = this.approveSelected.bind(this);
        this.claimSelected = this.claimSelected.bind(this);
    }

    componentDidMount() {
        if (!this.props.com) {
            SidebarGlobal.setSubNav(<><div className="btn-group">
                {!Auth.hasRole('readonly') && <Link to="/lead/new" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New Record</L></span></Link>}
                <button type="button" className="btn btn-secondary" onClick={() => this.load()}><Icon icon="faRefresh" /> <span className="d-none d-md-inline"><L>Refresh</L></span></button>
            </div></>);
        }
        qreq.get('/api/order/action/list', j => {
            if (j.list)
                this.setState({ actionList: j.list });
        });
        qreq.get('/api/lead/user/list', j => {
            if (j.list)
                this.setState({ userList: j.list });
        });
        qreq.get('/api/lead/type/list', j => {
            if (j.list) {
                var typeList = j.list;
                typeList.splice(0, 0, { id: -1, name: 'All', isDefault: true });
                typeList.push({ id: 0, name: 'Unclassified' });

                qreq.get('/api/lead/list/filter', j => {
                    var query = { ...this.state.query };
                    if (j.item) {
                        query = { ...j.item };
                    }
                    var find = typeList.find(a => a.isDefault === true);
                    if (!query.qfilters.LeadTypeID) {
                        query.qfilters = { LeadTypeID: String(find.id) };
                    }

                    if (this.props.referringAccountID)
                        query.qfilters.ReferringAccountID = this.props.ReferringAccountID;

                    this.setState({ query: query, typeList: typeList, defaultLeadType: find });
                    this.load(query);
                });
            }
        });
        qreq.get('/api/lead/source/list', j => {
            if (j.list)
                this.setState({ sourceList: j.list });
        });
        qreq.get('/api/account/list', j => {
            if (j.list) {
                j.list.splice(0, 0, { id: 0, name: 'All (Default)' });
                this.setState({ accountList: j.list });
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.page !== this.props.params.page) {
            var query = { ...this.state.query, page: Number(this.props.params.page ?? 1) };
            this.setState({ query: query });
            this.load(query);
        }
        if (prevProps.params.bucket !== this.props.params.bucket) {
            this.setState({ bucket: this.props.params.bucket });
            this.load();
        }
        if (prevProps.params.page !== this.props.params.page) {
            var query2 = { ...this.state.query, page: this.props.params.page };
            this.setState({ query2: query });
            this.load(query2);
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load(query) {
        if (!query)
            query = { ...this.state.query };
        if (query) {
            for (var k in query.qfilters) {
                if (query.qfilters[k])
                    query.qfilters[k] = String(query.qfilters[k]);
                else
                    delete query.qfilters[k];
            }
        }

        query.page = this.props.params.page ?? 1;

        if (this.props.referringAccountID)
            query.qfilters.ReferringAccountID = this.props.referringAccountID;

        this.setState({ loading: true });
        this.loading = true;
        qreq.post('/api/lead/list?bucket=' + (this.props.params.bucket ?? 'default') + (this.props.com ? '&saveFilter=false' : ''), query, j => {
            if (j.list) {
                Globals.processResultObject(j);
                j.list.forEach(i => {
                    try {
                        i.survey = JSON.parse(i.surveyJsonData);
                    }
                    catch {
                        i.survey = {};
                    }
                })
                this.setState({ list: j.list, pageCount: j.pageCount, totalCount: j.totalCount });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
            this.loading = false;
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
            this.loading = false;
        });
    }

    search(e) {
        if (e)
            e.preventDefault();

        if (this.loading) {
            setTimeout(() => this.search(), 100);
            return;
        }

        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 1000);
    }

    onSort(col) {
        var name = col.name;

        if (name === 'insurance')
            return;

        if (name === 'patientNameDOB')
            name = 'UPPER(p.firstname||\' \'||p.lastname)';
        else if (name === 'accountName')
            name = 'a.name';
        else if (name === 'referrerName')
            name = 'UPPER(re.firstname||\' \'||re.lastname)'
        else if (name === 'createdByUserName')
            name = 'UPPER(cbu.firstname||\' \'||cbu.lastname)'
        else if (name === 'assignedToUserName')
            name = 'UPPER(au.firstname||\' \'||au.lastname)'
        else if (name === 'leadTypeName')
            name = 'lt.name';
        else if (name === 'leadSourceName')
            name = 'o.facilityname ' + (col.asc ? 'ASC' : 'DESC') + ', ls.name';
        else if (name === 'orderNextActionName')
            name = 'oa.name';
        else if (name === 'referringAccountName')
            name = 'ra.name';
        else if (name === 'createdDate')
            name = 'o.createddate';
        else if (name === 'approval')
            name = null;
        else {

            if (name === 'oid')
                name = 'id';
            else if (name === 'status')
                name = 'status';
            else
                name = name.charAt(0).toUpperCase() + name.slice(1);

            name = 'o.' + name.toLowerCase();
        }
        var query = { ...this.state.query };
        if (name)
            query.sort = name + ' ' + (col.asc ? 'ASC' : 'DESC');
        else
            query.sort = null;
        this.setState({ query: query });
        this.load(query);
    }

    onFilter(col) {
        var query = { ...this.state.query };

        if (col.filter.value)
            query.qfilters[col.filter.filter] = col.filter.value;
        else
            delete query.qfilters[col.filter.filter];
        this.setState({ query: query });
        this.load(query);
    }

    hasFilters() {
        var find = this.state.typeList.find(a => a.id === Number(this.state.query.qfilters.LeadTypeID));

        if (find && !find.isDefault)
            return true;

        for (var k in this.state.query.qfilters) {
            if (k === 'LeadTypeID')
                continue;
            if (this.state.query.qfilters[k])
                return true;
        }

        if (this.state.query.search)
            return true;
    }

    resetFilters() {
        var query = {
            page: this.props.params.page ?? 1,
            qfilters: {
                LeadTypeID: String(this.state.defaultLeadType ? this.state.defaultLeadType.id : 0)
            }
        };

        if (this.props.referringAccountID)
            query.qfilters.ReferringAccountID = this.props.ReferringAccountID;

        this.setState({ query: query });
        this.load(query);
    }

    approveSelected() {
        var list = this.state.list.filter(i => i.checked);
        if (list.length === 0) {
            Pop.show('Please select at least one referral to approve.', 'Message');
            return;
        }
        Pop.showConfirm('Are you sure you want to approve the selected referrals?', 'Confirm', () => {
            var counter = 0;
            var callback = () => {
                counter++;
                if (counter >= list.length)
                    this.load();
            };
            list.forEach(i => {
                qreq.post('/api/lead/refer/out/approve', i, j => {
                    if (j.errorCode === 0) {
                        this.success('Approved referral ' + i.id);
                    }
                    else {
                        this.alert('Error approving referral ' + i.id + ': ' + j.errorMessage);
                    }
                    callback();
                }, () => {
                    this.unkownErrorCallback();
                    callback();
                });
            })
        });
    }

    claimSelected() {
        var list = this.state.list.filter(i => i.checked);
        if (list.length === 0) {
            Pop.show('Please select at least one referral to claim back.', 'Message');
            return;
        }
        Pop.showConfirm('Are you sure you want to claim back the selected referrals?', 'Confirm', () => {
            var counter = 0;
            var callback = () => {
                counter++;
                if (counter >= list.length)
                    this.load();
            };
            list.forEach(i => {
                qreq.post('/api/lead/refer/out/set', { ...i, isReferOut: false }, j => {
                    if (j.errorCode === 0) {
                        this.success('Claimed back referral ' + i.id);
                    }
                    else {
                        this.alert('Error claiming back referral ' + i.id + ': ' + j.errorMessage);
                    }
                    callback();
                }, () => {
                    this.unkownErrorCallback();
                    callback();
                });
            });
        });

    }


    exportList = () => {
        window.location.href = Globals.serverUrl + '/api/lead/export';
    }


    render() {
        if (this.props.params.bucket === 'inbound')
            this.props.params.bucket = null;
        const header = !this.props.com ? (this.props.params.bucket === 'onhold' ? <h1><L>On Hold</L></h1> : this.props.params.bucket === 'pending' ? <h1><L>Outbound Pending</L></h1> : this.props.params.bucket === 'outbound' ? <h1><L>Outbound Referral</L></h1> : <h1><L>Inbound Referral</L></h1>) : '';

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        var leadTypeName = 'Patient';
        var leadType = this.state.typeList.find(a => a.id === Number(this.state.query.qfilters.LeadTypeID));
        if (leadType)
            leadTypeName = leadType.name;

        var columns = [
            {
                name: '_', link: '/lead/edit/:id', tooltip: 'View Lead', className: 'text-center', valueFunc: row => {
                    if (row.lockByUserID)
                        return <><Icon icon="faLock" className="text-danger" />
                            <Rating rating={row.rating} small brief />
                        </>;
                    return <Rating rating={row.rating} small brief />;
                }
            },
            {
                name: 'referrerName', title: 'Caller', link: '/lead/edit/:id', tooltip: 'View Lead', valueFunc: row => {
                    if (row.lockByUserID)
                        return <><div className="d-flex align-items-center"><div>{row.referrerName}</div></div><div className="d-block text-muted">Locked by: {row.lockByUserName}</div></>;
                    return <div className="d-flex align-items-center"><div>{row.referrerName}</div></div>;
                }
            },
            {
                name: 'referringAccountName', title: 'Referring', valueFunc: row => {
                    if (!row.referringAccountName)
                        return 'None';
                    return row.referringAccountName;
                }
            },
            {
                name: 'leadSourceName', title: 'Facility', valueFunc: row => {
                    if (!row.leadSourceName && !row.facilityName)
                        return 'N/A';
                    return (row.facilityName ? row.facilityName + ' - ' : '') + (row.leadSourceName ?? '');
                }
            },
            { name: 'createdDate', title: 'Created', format: 'datetime', className: 'd-none d-md-table-cell' },
            { name: 'modifiedDate', title: 'Modified', format: 'datetime', className: 'd-none d-md-table-cell' }
        ];

        if (!this.props.params.bucket || this.props.params.bucket === 'onhold') {

            if (Auth.hasRole('manager')) {
                columns.splice(5, 0, {
                    name: 'orderNextActionName', title: 'Next Action', valueFunc: row => {
                        if (!row.orderNextActionName)
                            return 'None';
                        return row.orderNextActionName;
                    }
                });
                columns.splice(6, 0, {
                    name: 'assignedToUserName', title: 'Assigned', className: 'd-none d-md-table-cell', valueFunc: row => {
                        if (row.assignedToUserName)
                            return row.assignedToUserName;
                        if (row.assigedToUserName === 0)
                            return 'Unassigned';
                        else {
                            if (row.createdByUserID === 0)
                                return 'Unassigned';
                            else
                                return row.createdByUserName;
                        }
                    }
                });
            }
        }

        const leadTypeID = Number(this.state.query.qfilters.LeadTypeID ?? -1);
        const patientLeadType = this.state.typeList.find(a => a.name === 'Patient');
        const partnerLeadType = this.state.typeList.find(a => a.name === 'Partner');
        if (leadTypeID === -1 || (patientLeadType && leadTypeID === patientLeadType.id) || (partnerLeadType && leadTypeID === partnerLeadType.id)) {

            columns.splice(2, 0, {
                name: 'patientNameDOB', title: 'Patient', link: '/lead/edit/:id', valueFunc: row => {
                    if (row.patientNameDOB === 'Unknown (Unknown)')
                        return 'N/A';
                    return row.patientNameDOB;
                }
            });

            if ((!this.props.params.bucket || this.props.params.bucket === 'onhold') && Auth.hasRole('manager')) {
                columns.splice(3, 0, {
                    name: 'approval', title: 'Approval(SIC)', valueFunc: row => {
                        var val = [];
                        if (row.isServiceApproved)
                            val.push(<Icon icon="faCheck" className="d-block text-success" title="Service Approval Approved" />);
                        else if (row.isServiceDeclined)
                            val.push(<Icon icon="faTimes" className="d-block text-danger" title="Service Approval Declined" />);
                        else {
                            if (row.serviceApprovalCount > 0)
                                val.push(<span className="d-block text-light bg-warning rounded-circle align-bottom text-center" style={{ fontSize: '0.5rem', width: '14px', height: '14px', paddingTop: '1px' }} title="Service Approval Pending">{row.serviceApprovalCount}</span>);
                            else
                                val.push(<Icon icon="faCircleQuestion" className="d-block text-secondary" title="Service Approval Pending" />);
                        }
                        val.push(' ');
                        if (row.isIVRApproved)
                            val.push(<Icon icon="faCheck" className="d-block text-success" title="IVR Approved" />);
                        else if (row.isIVRDeclined)
                            val.push(<Icon icon="faTimes" className="d-block text-danger" title="IVR Declined" />);
                        else
                            val.push(<Icon icon="faCircleQuestion" className="d-block text-secondary" title="IVR Pending" />);
                        val.push(' ');
                        if (row.isClinicalApproved)
                            val.push(<Icon icon="faCheck" className="d-block text-success" title="Clinical Approval Approved" />);
                        else if (row.isClinicalDeclined)
                            val.push(<Icon icon="faTimes" className="d-block text-danger" title="Clinical Approval Declined" />);
                        else {
                            if (row.clinicalApprovalCount > 0)
                                val.push(<span className="d-block text-light bg-warning rounded-circle align-bottom text-center" style={{ fontSize: '0.5rem', width: '14px', height: '14px', paddingTop: '1px' }} title="Clinical Approval Pending">{row.clinicalApprovalCount}</span>);
                            else
                                val.push(<Icon icon="faCircleQuestion" className="d-block text-secondary" title="Clinical Approval Pending" />);
                        }
                        return <div className="d-flex align-items-stretch justify-content-evenly">{val}</div>;
                    }
                });
            }
            columns.splice(3, 0, {
                name: 'insurance', title: 'Insurance', valueFunc: row => {
                    var ar = [];
                    if (row.survey.insuranceMedicare)
                        ar.push('Traditional Medicare');
                    if (row.survey.insuranceMedicareReplacement)
                        ar.push('Medicare Replacement');
                    if (row.survey.insuranceMedicaid)
                        ar.push('Medicaid');
                    if (row.survey.insurancePPO)
                        ar.push('PPO');
                    if (row.survey.insuranceHMO)
                        ar.push('HMO');
                    if (row.survey.insuranceOther)
                        ar.push('Supplemental');
                    return ar.join(', ');
                }
            });
        }

        if (this.props.params.bucket === 'pending') {
            columns.splice(0, 0, {
                name: 'checked', title: '', className: 'text-center', valueFunc: row => {
                    return <input type="checkbox" checked={row.checked} onChange={() => { row.checked = !row.checked; this.setState({ list: this.state.list }) }} />;
                }
            });
        }


        return <div className="container-fluid">
            {!this.props.com && <LeadsMenu />}
            {header}
            {!this.props.com && <AppActions noBack>
                <button type="button" className="d-block d-md-none btn btn-secondary btn-lg" onClick={() => this.props.navigate('/menu')}>
                    <Icon icon="faBars" /> <L>Menu</L></button>
                <Dropdown drop="up" className="d-block">
                    <Dropdown.Toggle variant="secondary" className="btn-lg"><L>Actions</L></Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={this.exportList}>
                            <Icon icon="faFileExcel" /> <L>Export</L></Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </AppActions>}
            {this.props.params.bucket === 'pending' && Auth.hasRole('admin') && <div className="app-actions">
                <div>
                    <button type="button" className="btn btn-secondary" onClick={() => {
                        var list = this.state.list;
                        list.forEach(i => i.checked = true);
                        this.setState({ list: list });
                    }}><Icon icon="faCheckSquare" /> <span className="d-none d-md-inline"><L>Select All</L></span></button>
                    <button type="button" className="btn btn-secondary" onClick={() => {
                        var list = this.state.list;
                        list.forEach(i => i.checked = false);
                        this.setState({ list: list });
                    }}><Icon icon="faSquare" /> <span className="d-none d-md-inline"><L>Select None</L></span></button>
                </div>
                <div className="flex-fill text-end">
                    <DropdownButton title="Actions" size="lg" drop="up" className="has-icons">
                        <Dropdown.Item onClick={this.approveSelected}><Icon icon="faCheck" /> <L>Approve Referral</L></Dropdown.Item>
                        <Dropdown.Item onClick={this.claimSelected}><Icon icon="faHandshakeAngle" /> <L>Claim Back</L></Dropdown.Item>
                    </DropdownButton>
                </div>
            </div>}
            <form onSubmit={this.search}>
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search the queue by patient name, caller name, or facility name,..." labelAsPlaceholder onChange={() => this.search()} />
                </div>
                {!this.props.com && (!this.props.params.bucket || this.props.params.bucket === 'onhold') && Auth.hasRole('manager') && <div className="d-flex mb-3">
                    <div>
                        <FormInput model={this.state.query.qfilters} name="ReferringAccountID" label="Referring" type="select-search" options={this.state.accountList} onChange={() => this.search()} />
                    </div>
                    <div className="ms-2">
                        <FormInput model={this.state.query.qfilters} name="OrderNextActionID" label="Action" type="select" options={this.state.actionList} onChange={() => this.search()} />
                    </div>
                    <div className="ms-2">
                        <FormInput model={this.state.query.qfilters} name="AssignedToUserID" label="Assigned" type="select" options={this.state.userList} onChange={() => this.search()} />
                    </div>
                    <div className="ms-2">
                        <FormInput model={this.state.query.qfilters} name="LeadSourceID" label="Facility Type" type="select" options={this.state.sourceList} onChange={() => this.search()} />
                    </div>
                    <div className="ms-2">
                        <FormInput model={this.state.query.qfilters} name="Rating" label="Rating" type="select" options={[
                            { id: 1, name: '* 1 star' },
                            { id: 2, name: '** 2 star' },
                            { id: 3, name: '*** 3 star' }
                        ]} onChange={() => this.search()} />
                    </div>
                    <div className="ms-2 flex-fill pt-4 mt-2">
                        {this.hasFilters() ? <p className="text-info"><Icon icon="faInfo" /> <L>Filters are present.</L><span className="badge bg-danger" role="button" onClick={this.resetFilters}><L>RESET</L></span></p> : ''}
                    </div>
                </div>}
            </form>
            <div className="mt-2 d-none d-md-block">
                <DataTable columns={columns} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                    { name: 'status', title: 'Status', filter: 'status', type: 'select', options: this.state.statusList },
                    { name: 'createdDate', title: 'Created Date', filter: 'createddate', type: 'daterange' }
                ]} showFilters={false} onFilter={this.onFilter} showCheckboxes={this.state.showFilters} defaultSort="createdDate" defaultSortDesc />
                <div className="card-body">
                    <Paging baseLoc={'/lead/' + (this.props.params.bucket ?? 'inbound') + '/page/'} pageCount={this.state.pageCount} currentPage={this.state.query.page} onPageClick={(e) => this.setState({ loading: true })} />
                </div>
            </div>
            <div className="mt-2 d-block d-md-none">
                {this.state.list.length === 0 ? <Alert><L>There are no leads.</L></Alert> : ''}
                {this.state.list.map(i => <div key={i.id} className="d-block rounded data-link drop-shadow bg-light p-3 mt-2">
                    <h5>{this.props.params.bucket === 'pending' && Auth.hasRole('admin') && <><input type="checkbox" checked={i.checked} onChange={e => { e.stopPropagation(); i.checked = !i.checked; this.setState({ list: this.state.list }) }} /> </>}
                        <Link to={'/lead/edit/' + i.id} role="button">
                            {i.patientName && i.patientName !== ' ' ? <h5 className="text-primary"><span className="text-center d-inline-block" style={{ width: '25px' }}><FontAwesomeIcon icon={fa.faBedPulse} /></span> {i.patientNameDOB && i.patientNameDOB !== 'Unknown (Unknown)' ? i.patientNameDOB : ''}</h5>
                                : <h5 className="text-primary"><i><span className="text-center d-inline-block" style={{ width: '25px' }}><FontAwesomeIcon icon={fa.faPhone} /></span> {i.referrerName}</i></h5>}
                        </Link></h5>
                    <Link to={'/lead/edit/' + i.id} role="button">
                        <div className="text-muted">Lead Created: {Globals.toMDYHMLocalDateString(i.createdDate)}</div>
                        <div className="text-secondary">Created By: {i.createdByUserName}</div>
                        {i.orderNextActionName !== 'Don\'t Know Yet' ? <strong className="d-block">{i.orderNextActionName}</strong> : ''}
                    </Link>
                </div>)}
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(Leads);